import {mergeRight} from 'ramda'

const initialState = {
  enrichment: {},
}

const sfdcEnrichment = function(state = initialState, action) {
  const { enrichment } = state
  switch (action.type) {
    case "FETCH_SALESFORCE_ENRICHMENT_STARTED":
      enrichment[action.key] = {
        loading: true,
        error: {},
        data: {},
      }
      return mergeRight(state, { enrichment: enrichment })

    case "FETCH_SALESFORCE_ENRICHMENT_FAILED":
      enrichment[action.key] = {
        loading: false,
        error: action.err,
        data: {},
      }
      return mergeRight(state, { enrichment: enrichment })

    case "FETCH_SALESFORCE_ENRICHMENT_SUCCESS":
      enrichment[action.key] = {
        loading: false,
        error: {},
        data: action.data,
      }
      return mergeRight(state, { enrichment: enrichment })

    default:
      return state
  }
}

export default sfdcEnrichment
